module.exports = __webpack_public_path__ + "img/download-light.e0eb468c.svg";